import { Component } from '@angular/core';

@Component({
  selector: 'globot-expired-plan',
  templateUrl: './expired-plan.component.html',
  styleUrls: ['./expired-plan.component.scss'],
})
export class ExpiredPlanComponent {
  options = {
    path: '/assets/lotties/bell.json',
  };
  visible: boolean = true;
  showPlansDialog: boolean = false;

  closeNotification(): void {
    this.visible = false;
    localStorage.setItem('showExpiredPlan', 'false');
  }
}
